<script lang="ts" setup>
import { provide } from "vue";
import { storeToRefs } from "pinia";
import { usePipStore } from "@/store/pip.store";
import { PIP_ATTACH_KEY } from "@/constants/pip";

const pipStore = usePipStore();
const { pipContainer, content } = storeToRefs(pipStore);

provide(PIP_ATTACH_KEY, pipContainer);
</script>

<template>
  <teleport v-if="pipContainer && content" :to="pipContainer">
    <v-defaults-provider :defaults="{ global: { attach: pipContainer } }">
      <component :is="content.component" v-bind="content.props" v-on="content.on ?? {}" />
    </v-defaults-provider>
  </teleport>
</template>

<style lang="scss">
.pip-layout {
  height: 100vh;
  overflow: hidden;
}

.pip-root {
  height: 100vh;
  overflow-y: scroll;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
